export default {
  'initial.dataset.errorLine': function () {
    return {
      'path.appearing': () => {
        return [{
          initialAttr: {
            opacity: 0
          },
          finalAttr: {
            opacity: 1
          },
          startEnd: {
            start: 0.5,
            end: 1
          },
          slot: 'plot'
        }];
      },
      '*': null
    };
  }
};
